import React, {useContext} from "react";
import LanguageContext from "../../contexts/LanguageContext";
import "./LanguageToggle.scss";

export default function LanguageToggle() {
  const {lang, setLang} = useContext(LanguageContext);

  return (
    <div className="language-toggle" role="group" aria-label="Language switch">
      <button
        type="button"
        className={lang === "en" ? "language-toggle-btn active" : "language-toggle-btn"}
        aria-pressed={lang === "en"}
        onClick={() => setLang("en")}
      >
        EN
      </button>
      <button
        type="button"
        className={lang === "de" ? "language-toggle-btn active" : "language-toggle-btn"}
        aria-pressed={lang === "de"}
        onClick={() => setLang("de")}
      >
        DE
      </button>
    </div>
  );
}
